import React from 'react';
import { Space, Typography } from 'antd';
import {
  bool, node, number, oneOfType, string,
} from 'prop-types';
import { ExpandMoreIcon } from 'components/cwo-icons';
import IconWrapper from './IconWrapper';

const { Text } = Typography;

const valueFormatter = (value) => (
  value.length > 12 ? value.slice(0, 9).concat('...') : value
);

const ButtonContent = ({
  dispatcherTimerContent = null,
  icon,
  iconBackgroundColor,
  id,
  label,
  showExpandIcon = true,
  value,
}) => (
  <Space size={4}>
    <IconWrapper backgroundColor={iconBackgroundColor}>
      {icon}
    </IconWrapper>
    <Space id={id} direction="vertical" size={0} align="start">
      <Text type="secondary" className="top-menu-field-groups__btn-text-container__label">
        {label}
      </Text>
      <Text>
        {dispatcherTimerContent}
        {valueFormatter(value)}
      </Text>
    </Space>
    {showExpandIcon && <ExpandMoreIcon />}
  </Space>
);

ButtonContent.propTypes = {
  dispatcherTimerContent: node,
  icon: node.isRequired,
  iconBackgroundColor: string.isRequired,
  id: string.isRequired,
  label: string.isRequired,
  showExpandIcon: bool,
  value: oneOfType([string, number]).isRequired,
};

export default ButtonContent;
